import React from "react";

import { ArrowDownIcon } from "@heroicons/react/outline";

import HeroSection from "../../hero-section";

const WhereverYourProcess = () => (
  <div className="bg-navy-dark text-white text-lg font-light">
    <HeroSection className="sm:py-8 lg:py-12">
      <div className="md:w-2/3 xl:w-1/2 mx-auto">
        <HeroSection.Content className="md:text-center">
          <div className="text-base text-gray-100 mt-4">
            <p>
              Wherever your process fits within the sales journey, Enerflo has tools and integrations to streamline the
              process. You’ve never sold like this before.
            </p>
            <ArrowDownIcon className="motion-safe:animate-bounce mt-6 inline-block h-6 w-6 md:h-8 md:w-8" />
          </div>
        </HeroSection.Content>
      </div>
    </HeroSection>
  </div>
);

export default WhereverYourProcess;
